export const AdsEfakturRBAC = {
  pageID: '86074e7af5df8757c7fa09bc10a1b7ab',
  elementID: {
    ViewFakturTable: '0d0a24c77c1f5a169020ace66bfe8b04',
  },
} as const
